import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Link } from 'components'
import { useActivateUser } from 'api'
import { LoginWrapper } from '../LoginWrapper'
import { useTranslation } from 'react-i18next'

export const ActivationPage = () => {
  const { t } = useTranslation()
  let location = useLocation()
  const token = new URLSearchParams(location.search).get('token')

  const [mutate, { status }] = useActivateUser()
  useEffect(() => {
    if (token) {
      mutate({ token })
    }
  }, [mutate, token])

  if (status === 'success') {
    return (
      <LoginWrapper title={t('pages.login.activationPage.success.title')}>
        <p>{t('pages.login.activationPage.success.info')}</p>

        <p>
          <Link to="/login">{t('pages.login.activationPage.toLogin')}</Link>
        </p>
      </LoginWrapper>
    )
  } else if (status === 'failure') {
    return (
      <LoginWrapper title={t('pages.login.activationPage.error.title')}>
        <p>{t('pages.login.activationPage.error.message')}</p>
        <p>{t('pages.login.activationPage.error.info')}</p>

        <p>
          <Link to="/register">
            {t('pages.login.activationPage.toRegister')}
          </Link>
        </p>
      </LoginWrapper>
    )
  }
  return null
}
